import { render, staticRenderFns } from "./draggable-list.vue?vue&type=template&id=40ac16a6"
import script from "./draggable-list.vue?vue&type=script&lang=js"
export * from "./draggable-list.vue?vue&type=script&lang=js"
import style0 from "./draggable-list.vue?vue&type=style&index=0&id=40ac16a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports